export const authEndpoints = {
  login: "/auth/token/obtain/",
  loginObtain: "/auth/token/login-obtain/",
  registerUsers: "/auth/users/",
  getUserEmail: "/auth/get-user-email/",
  resendCode: "/auth/resend-code/",
  verifyEmail: "/auth/verify-code/",
  setPassword: "/auth/public-set-password/",
  recoveryRequest: "/auth/recovery-request/",
  recoveryRequestPassword: "/auth/recovery-reset-password/",
  resetPin: "/auth/reset-pin-request/",
  refreshToken: "/auth/token/refresh/",
  resetPinVerify: "/auth/reset-pin-verify/",
  loginWithGoogle: "/auth/google/mobile/",
  loginWithApple: "/auth/apple/callback/",
  getWorkplaces: "/auth/workplaces/",
  postHowDidYouFind: "/auth/find-from/",
};
